import store from "../store";
export const getToken = () => store.getState()?.authReducer?.token;
